import React, { useEffect, useState } from 'react'
// import Button from "../button";
import styles from './embassies_modal.module.css'
import { student } from '../../store/student'
import { report } from '../../store/report'
import http from '../../Service/http'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';

const TemporaryСertificateModal = ({ openForm, openSpravka }) => {
	const [modalData, setModalData] = useState([])
	const [isSave, setIsSave] = useState(false)
	const [refusal, setRefusal] = useState(false)
	const [updateNaz, setUpdateNaz] = useState({
		order_number: '',
		diploma_series: '',
		diploma_number: '',
		surname: '',
		qualification: '',
		work: '',
		naznachenie: '',
		naznachenie_kg: '',
		application: '',
		with_honors: false
	})
	const [reasonRefusal, setReasonRefusal] = useState({
		rejected_komment: ''
	})

	const day_c_os = new Date().getDay()
	const month_c_os = new Date().getMonth() + 1;
	const year_c_os = new Date().getFullYear() 

	const day_po_os = new Date().getDay()
	const month_po_os = new Date().getMonth() + 1;
	const year_po_os = new Date().getFullYear()

	const [updateData, setUpdateData] = useState({
		date_of_the_decision_SAC: `${year_c_os}-${month_c_os}-${day_c_os}`,
		date_of_issue: `${year_po_os}-${month_po_os}-${day_po_os}`
	})


	const { t, i18n } = useTranslation()



	const openInput = () => {
		setRefusal(!refusal)
	}

	const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
	  PaperProps: {
		style: {
		  maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,			
		  width: 250,
		},
	  },
	};

	// const getReports = async id => {
	// 	const a = await http.post('/report/reportApplicationWait?reportType=' + id)
	// 	report.newReport(a.data.reportApplicationWait)
	// }

	const getModaldata = async () => {
		const res = await http.post('/okno/modaldata', {
			uid: student.student.id_student,
			gid: student.student.id_group,
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document
		})
		setModalData(res.data.data)
		setUpdateNaz({ 
			order_number: res.data.data.order_number, 
			diploma_series: res.data.data.diploma_series, 
			diploma_number: res.data.data.diploma_number, 
			surname: res.data.data.FIOnew, 
			qualification: res.data.data.qualification, 
			work: res.data.data.name_company, 
			naznachenie: res.data.data.naznachenie, 
			naznachenie_kg: res.data.data.naznachenie_kg, 
			application: res.data.data.year_of_working_out, 
			with_honors: res.data.data.with_honors, 
		})
		setUpdateData({date_of_the_decision_SAC:dayjs(res.data.data.date_of_the_decision_SAC).format("YYYY-MM-DD"),
			date_of_issue:dayjs(res.data.data.diploma_date).format("YYYY-MM-DD")})
	}

	const getArchiveModaldata = async () => {
		const res = await http.post('/okno/archiveModaldata', {
			uid: student.student.id_student,
			gid: student.student.id_group,
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document
		})
	}
	
	// процедура на модального окно для сохранения данных в справках
	const updateModalDate = async () => {
		const date_of_the_decision_SAC = dayjs(updateData.date_of_the_decision_SAC).format('YYYY-MM-DD HH:mm:ss')
		// console.log("date_c",date_c)
		const date_of_issue = dayjs(updateData.date_of_issue).format('YYYY-MM-DD HH:mm:ss')
		// console.log("datepo",date_po)

		const res = await http.post('/okno/modalDateUpdate', {
			id_zakaz: student.student.id_okno_zakaz,
			uid: student.student.id_student,
			gid: student.student.id_group,
			doc: student.student.id_okno_document,
			order_number: updateNaz.order_number,
			diploma_series: updateNaz.diploma_series,
			diploma_number: updateNaz.diploma_number,
			surname: updateNaz.surname,
			qualification: updateNaz.qualification,
			work: updateNaz.work,
			naznachenie: updateNaz.naznachenie,
			naznachenie_kg: updateNaz.naznachenie_kg,
			application: updateNaz.application,
			with_honors: updateNaz.with_honors,
			date_of_the_decision_SAC: date_of_the_decision_SAC,
			date_of_issue: date_of_issue,
		})
		if (res.data.result !== null) {
			toast(res.data.result)
		}
		setIsSave(false)
		// console.log("update Embass", res);
	}


	const postReasonRefusal = async () => {
		const res = await http.post('/okno/reasonRefusal', {
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document,
			rejected_komment: reasonRefusal.rejected_komment
		})
		if (res.data.result == null) {
			toast(res.data.result)
			// getReports(0)
			openForm()
			// setIsSave(false)
		}
		// console.log("update", res);
	}

	React.useEffect(() => {
		document.body.style.overflowY = 'hidden'
		return () => (document.body.style.overflowY = 'visible')
	}, [])

	// React.useEffect(() => {
	// 	getReports(0)
	// }, [])

	React.useEffect(() => {
		if (openForm) {
			getModaldata()
			getArchiveModaldata()
		}
	}, [])

	const change = e => {
		const { name, value } = e.target
		setUpdateNaz({ ...updateNaz, [name]: value })
		console.log(':nameval', { [name]: value })
		setIsSave(true)
		console.log('issave', isSave)
	}

	const changeCheck = e => {
		setUpdateNaz({
			...updateNaz,
			[e.target.name]: e.target.checked
		})
		setIsSave(true)
	}

	const onChangeDate = e => {
		setUpdateData({
			...updateData,
			[e.target.name]: e.target.name == 'with_honors' ? e.target.checked : e.target.value
		})
		setIsSave(true)
	}



	const changeRefusal = e => {
		const { name, value } = e.target
		setReasonRefusal({ ...reasonRefusal, [name]: value })
		console.log(':reasonRefusal', { [name]: value })
	}
	
	
	return (
		<div className={styles.modal}>
			<div className={styles.modal_window}>
				<div className={styles.modal_window_head}>
					<div></div>
					<label>{modalData.okno_document}</label>
					{!refusal ? (
						<div className={styles.add_form_stud_exit}>
							{updateNaz.qualification?.length >= 4 ? (
								<a
									className='new_report'
									target='_blank'
									href={`/bt/api/r/timely?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&lang=${i18n.language}`}
								>
									<button className={styles.button_modal} onClick={openForm}>
										Просмотр
									</button>
								</a>
							) : null} 
						</div>
					) : (
						<div></div>
					)}
				</div>
				
				{!refusal ? (
					<div>
						<div className={styles.name_student}>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Студент:</span>
								<p>{modalData?.fio}</p>
							</div>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Уникальный номер справки:</span>
								<p>{modalData.reference_number}</p>
							</div>
						</div>
						<div className={styles.modal_window_data}>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>ФИО:</span>
								<input
									className={styles.input_modal}
									type='text'
									placeholder='ф.и.о'
									name='surname'
									value={updateNaz.surname}
									onChange={change}
								>
								</input>
							</div>

							<div className={styles.input_block}>
								<div className={styles.new_input_block_date}>
									<span className={styles.name_student_text}>№ протокола:</span>
									<input
										onChange={change}
										className={styles.input_modal_date}
										type='text'
										placeholder='номер протокола'
										name='order_number'
										value={updateNaz.order_number}
									/>
								</div>
								<div className={styles.new_input_block_date2}>
									<span className={styles.name_student_text}>Дата решения ГАК:</span>
									<input
										onChange={onChangeDate}
										className={styles.input_modal_date}
										type='date'
										placeholder='YYYY'
										name='date_of_the_decision_SAC'
										value={updateData.date_of_the_decision_SAC}
									/>
								</div>
							</div>
							<div className={styles.input_block}>
									<div className={styles.new_input_block_date}>
										<span className={styles.name_student_text}>№свидетельства:</span>
										<input
											onChange={change}
											className={styles.input_modal_date}
											type='text'
											placeholder='серия диплома'
											name='diploma_number'
											value={updateNaz.diploma_number}
										/>
									</div>
									<div className={styles.new_input_block_date2}>
										<span className={styles.name_student_text}>Дата свидетельства:</span>
										<input
											onChange={onChangeDate}
											className={styles.input_modal_date}
											type='date'
											placeholder='YYYY'
											name='date_of_issue'
											value={updateData.date_of_issue}
										/>
									</div>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Наименование предприятия:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='work'
									value={updateNaz.work}
									onChange={change}
								>
								</input>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Квалификация:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='qualification'
									value={updateNaz.qualification}
									onChange={change}
								>
								</input>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Максаты:</span>
								<input
									className={styles.input_modal}
									onChange={change}
									type='text'
									name='naznachenie_kg'
									value={updateNaz.naznachenie_kg}
								>
								</input>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Назначение:</span>
								<input
									className={styles.input_modal}
									onChange={change}
									type='text'
									name='naznachenie'
									value={updateNaz.naznachenie}
								>
								</input>
							</div>
							<div className={styles.input_block}>
									<div className={styles.new_input_block_date}>
										<span className={styles.name_student_text}>С отличием/без:</span>
										<input
											onChange={changeCheck}
											className={styles.input_modal_checkbox}
											type='checkbox'
											name='with_honors'
											checked={updateNaz.with_honors}
										/>
									</div>
									<div className={styles.new_input_block_date2}>
										<span className={styles.name_student_text}>Год отработки:</span>
										<input
											className={styles.input_modal_date}
											type='number'
											placeholder='год отработки'
											name='application'
											value={updateNaz.application}
											onChange={change}
										/>
									</div>
							</div>
						</div>

						<div className={styles.user}>
							<div className={styles.user_name}>
								<span className={styles.name_student_text}>Исполнитель:</span>
								<p>{modalData.AVN_operator}</p>
							</div>
						</div>
					</div>
				) : (
					<div className={styles.modal_window_data}>
						<div className={styles.input_block}>
							<span className={styles.name_student_text}>Причина отказа:</span>
							<input
								className={styles.input_modal}
								type='text'
								placeholder='Введите причину отказа...'
								name='rejected_komment'
								value={reasonRefusal.rejected_komment}
								onChange={changeRefusal}
							>
								{/* Причина отказа */}
							</input>
						</div>
					</div>
				)}

				<div className={styles.modal_footer}>
					<div></div>
					<div className={styles.footer_buttons}>
						{refusal ? (
							<>
								{reasonRefusal.rejected_komment?.length >= 4 ? (
									<button onClick={postReasonRefusal} className={styles.button_modal}>
										Отказать
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={postReasonRefusal}
									>
										Отказать
									</button>
								)}
								<button onClick={openInput} className={styles.button_modal}>
									Назад
								</button>
							</>
						) : (
							<>
								<button onClick={openInput} className={styles.button_modal}>
									Отказать
								</button>
								{updateNaz.qualification?.length >= 3 && isSave ? (
									<button className={styles.button_modal} onClick={updateModalDate}>
										Сохранить
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={updateModalDate}
									>
										Сохранить
									</button>
								)}
								<button onClick={openForm} className={styles.button_modal}>
									Закрыть
								</button>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default TemporaryСertificateModal
